import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { AnimatePresence, motion } from "framer-motion";
import "./NFTModal.scss";
import nftModalStyles from "./nftModalStyles";
import { NFTInfo, NFTNames } from "types";
import { observer } from "mobx-react-lite";
import NFTStore from "stores/NFTStore";

type Props = {
  selectedImage: string;
  setSelectedImage: any;
  NFTs?: NFTInfo[];
  name: NFTNames;
};

const defaultState = {
  opacity: 0,
  scale: 0.6,
};

function NFTModal({ selectedImage, setSelectedImage, NFTs, name }: Props) {
  const currentNFT = (NFTs && NFTs[0]) || null;
  const { nftApprovals } = NFTStore;
  const oldApproval = nftApprovals.get(name as NFTNames);
  const approved = oldApproval && oldApproval.find((a) => a.tokenId === currentNFT?.tokenId && a.hasApproval);
  const [hasApproval, setHasApproval] = useState(approved?.hasApproval);

  useEffect(() => {
    (async () => {
      if (currentNFT && !hasApproval) {
        const approval = await NFTStore.getApproved(name as NFTNames, currentNFT.tokenId);
        setHasApproval(approval);
      }
    })();
  }, [hasApproval, currentNFT, name]);

  const { nftsInUse } = NFTStore;
  const inUse = nftsInUse.get(name);
  return (
    <Modal
      isOpen={selectedImage ? true : false}
      onRequestClose={() => setSelectedImage("")}
      contentLabel="Pool Info"
      style={nftModalStyles}
    >
      <AnimatePresence>
        <motion.div
          className="nft-image-container"
          initial={defaultState}
          exit={defaultState}
          animate={{
            opacity: 1,
            boxShadow: "1px 1px 10px rgba(0, 0, 0, 0.3)",
            scale: 1,
          }}
        >
          <img src={selectedImage} alt="nft" />
          <div className="nft-info">
            <b>{name}</b> <br />
            10% boost for an epoch
          </div>
          {inUse && (
            <div className="nft-use-button disabled" style={{ fontSize: "18px", padding: "3px 0px" }}>
              <b>NFT in use for current epoch!</b>
            </div>
          )}
          {hasApproval && !inUse && (
            <div
              className="nft-use-button clickable"
              // eslint-disable-next-line react-hooks/rules-of-hooks
              onClick={() => currentNFT && NFTStore.useNFT(name as NFTNames, currentNFT.tokenId, () => setSelectedImage(""))}
            >
              <b>Use (burn)</b>
            </div>
          )}
          {!hasApproval && !inUse && (
            <div
              className="nft-use-button clickable"
              onClick={() => currentNFT && NFTStore.approve(name as NFTNames, currentNFT.tokenId).then(() => setHasApproval(true))}
            >
              <b>Approve for usage</b>
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </Modal>
  );
}

export default observer(NFTModal);
